import {Component, Output, EventEmitter, Input, OnChanges, OnInit} from '@angular/core';
import { Rule } from '../services/capd.model';

@Component({
  selector: 'epic-message-editor',
  templateUrl: './epic-message-editor.component.html',
  inputs: ['rule', 'ruleClone', 'ruleChanged']
})

/**
 * Editor specifically for Epic NoteReader messages.
 */
export class NotereaderMessageEditorComponent implements OnInit, OnChanges {

  @Output() changed: EventEmitter<any> = new EventEmitter();
  @Input() rule: Rule;
  @Input() ruleClone: Rule;
  @Input() ruleChanged: boolean;
  newChanged: boolean;

  ngOnInit() {
      if (!this.rule.action.groups) {
        this.rule.action.groups = [
          {type: 'Text', messageText: this.rule.action.messageText, options: null},
          {type: 'Radio', messageText: null, options: ['']}
        ];
      }
  }

  ngOnChanges() {
    if (!this.rule.action.groups) {
      this.rule.action.groups = [
        {type: 'Text', messageText: this.rule.action.messageText, options: null},
        {type: 'Radio', messageText: null, options: ['']}
      ];
    }
  }

  /**
   * Sets the action type of the rule based on a given number.
   *
   * @func setType
   * @param {number} typeId - an ID number for the message type, used to switch.
   */
  setType() {
    if (this.rule.action.actionType.includes('Message')) {
      this.rule.action.actionType = 'Message, Instruction';
    } else {
      this.rule.action.actionType = 'Instruction';
    }
    this.rule.action.groups = [
      {type: 'Text', messageText: this.getMessageText(), options: null},
      {type: 'Radio', messageText: null, options: ['']}
    ];
  }

  private getMessageText() {
    const messageTextExists = (!!this.rule.action.messageText && this.rule.action.messageText !== '');
    const messageTextInGroupExists = (!!this.rule.action.groups[0] && this.rule.action.groups[0].messageText !== '');

    if (messageTextExists) {
      return this.rule.action.messageText;
    } else if (messageTextInGroupExists){
      return this.rule.action.groups[0].messageText;
    }
    else {
      return '';
    }
  }

  /**
   * Adds an additional option to the end of the list of suggestions.
   *
   * @func addListOption
   */
  addListOption() {
    if (this.rule.action.groups[1].options.length >= 6) { return; }
    const newOption = {name: '', message: '', code: '', codeType: 'Snomed'};
    this.rule.action.groups[1].options.push(newOption);
  }

  /**
   * Removes an option from the list.
   *
   * @func removeListOption
   * @param {ActionGroup} option - the option to remove.
   */
  removeListOption(option) {
    this.rule.action.groups[1].options.splice(this.rule.action.groups[1].options.indexOf(option), 1);
  }

  /**
   * Called to check if the rule has been modified from how it appeared when it was last saved.
   *
   * @func isEdited
   */
  isEdited() {
    this.newChanged = !(JSON.stringify(this.rule) === JSON.stringify(this.ruleClone));
    if (this.ruleChanged !== this.newChanged){ this.changed.emit(this.newChanged); }
  }
}
